import React from "react";

const SchemaNephrology = () => {
  const schema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "Can kidney disease be cured?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Early-stage kidney disease can often be controlled with proper treatment and lifestyle changes. Severe cases may require dialysis or a transplant."
        }
      },
      {
        "@type": "Question",
        "name": "How often should kidney function be checked?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "People with diabetes, hypertension, or family history of kidney disease should test at least once a year."
        }
      },
      {
        "@type": "Question",
        "name": "Is dialysis painful?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Dialysis isn’t painful. Patients may feel mild discomfort initially, but most adjust quickly with proper care."
        }
      },
      {
        "@type": "Question",
        "name": "What foods should kidney patients avoid?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Limit salt, processed foods, red meat, and high-phosphorus items. Our dieticians will provide personalised plans."
        }
      },
      {
        "@type": "Question",
        "name": "Where is the best kidney care available in Patna?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "HDNA Aarogyam Hospital offers one of the most comprehensive nephrology and renal care facilities in Patna with 24x7 expert support."
        }
      },
      {
        "@type": "Question",
        "name": "When should I consult a nephrologist?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "You should see a nephrologist if you experience swelling, reduced urine output, persistent fatigue, uncontrolled blood pressure, or abnormal kidney test results."
        }
      },
      {
        "@type": "Question",
        "name": "What types of dialysis are available at HDNA Aarogyam Hospital?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "HDNA Aarogyam Hospital provides both haemodialysis and peritoneal dialysis under strict safety and infection-control protocols."
        }
      },
      {
        "@type": "Question",
        "name": "Does HDNA Aarogyam Hospital offer kidney transplant services?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes, our Institute of Renal Science & Renal Transplant provides complete kidney transplant care, including pre-transplant evaluation, surgery, and post-transplant follow-up."
        }
      },
      {
        "@type": "Question",
        "name": "Can kidney disease be managed without dialysis?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes, many kidney conditions can be managed with medication, diet, and lifestyle changes, especially when diagnosed early."
        }
      },
      {
        "@type": "Question",
        "name": "Is long-term follow-up required for kidney patients?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes, regular follow-ups are essential to monitor kidney function, prevent complications, and maintain long-term kidney health."
        }
      }
    ]
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
    />
  );
};

export default SchemaNephrology;
